import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchMatterParties {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  limit?: number;
  search?: string;
  id?: string;
  fields?: string[];
  type: string;
}
export const useFetchMatterParties = (params: IUseFetchMatterParties) => {
  const fetchMatterParties = async ({ pageParam = 1 }) => {
    const { relations: partiesRelations, id, type, extraFilters: filters, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (partiesRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    const url =
      type === 'matter'
        ? `${API_URLS.MATTER_PARTIES.replace(':id', String(id))}?${queryString.toString()}`
        : `${API_URLS.MATTER_REQUEST_PARTIES.replace(':id', String(id))}?${queryString.toString()}`;
    try {
      return await get(url);
    } catch (error) {
      console.error('Error fetching matter parties:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch matter parties');
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['matter-parties-list', params],
    queryFn: fetchMatterParties,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
